var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eu-display_flex eu-align-items_center_md eu-justify_center eu-pa_6",staticStyle:{"height":"500px"}},[_c('emd-loader',{attrs:{"type":"_invert"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }